"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const Styles = {
    container: (isChecked, isDisabled) => core_1.css `
    opacity: ${isDisabled ? 0.5 : 1};
    cursor: ${isDisabled ? 'not-allowed' : 'pointer'};

    ${isChecked ? `
        input :after { display: block; }
      ` : ''}
  `,
    checkmark: (isChecked, hasError, indeterminate) => core_1.css `
    background-color: ${isChecked || indeterminate ? styles_scss_1.default.primary : styles_scss_1.default.white} !important;
    border-color: ${(hasError && styles_scss_1.default.red) || (isChecked || indeterminate ? 'transparent' : styles_scss_1.default.grey)} !important;

    ${
    // This is the Checkmark that appears on Selection
    (isChecked && `
        &:after {
          display: block;
          border: solid #fff;
          border-width: 0 3px 3px 0;
          content: '';
          height: 10px;
          left: 5px;
          position: absolute;
          top: 1px;
          transform: rotate(45deg);
          width: 3px;
        }
      `) ||
        // This is in the indeterminate state a white dash will appear
        (indeterminate ? `
        &:after {
          display: block;
          border: none;
          content: '';
          height: 3px;
          left: 2.9px;
          position: absolute;
          top: 7px;
          width: 12px;
          background-color: #fff;
          transform: none;
        }
      ` : '')}
  `,
    label: (hasError) => core_1.css `
    color: ${hasError ? styles_scss_1.default.red : styles_scss_1.default.black};
  `
};
exports.default = Styles;
